import requests from "./httpService";

const JobtitleServices = {

  addJobtitle: async (body) => {
    return requests.post(`/jobrole/add/`, body);
  },
  getAllJobtitle: async () => {
    return requests.get(`/jobrole/`);
  },
  getJobtitleById: async (id) => {
    return requests.get(`/jobrole/${id}`);
  },

  updateJobtitle: async (id, body) => {
    return requests.put(`/jobrole/update/${id}`, body);
  },

  deleteJobtitle: async (id) => {
    return requests.delete(`/jobrole/delete/${id}`);
  },
  updateActiveStatus:async(id,body) =>{
    return requests.post(`/jobrole/status/${id}`, body);
  },
 
};

export default JobtitleServices;
